import { z, ZodType } from "zod";

import type { FormSection } from "./FormSection.js";
import type { IncidentType } from "./incidentType.js";
import { IncidentTypeValues } from "./incidentType.js";
import type { ValueAndLabel } from "./workflow/index.js";

type FormSectionCompletedEndIncidentUnbranded = {
  endingReason: ValueAndLabel<
    | "startedFormInError"
    | "formExpired"
    | "nhsNotEngage"
    | "medicalExamination"
    | "other"
  >;
  incidentType?: IncidentType;
};

type FormSectionCompletePosUnbranded = {
  pos: string;
  arrivalDate: string;
};

const _FormSectionCompletePosSchema = z.object({
  pos: z.string(),
  arrivalDate: z.string(),
}) satisfies ZodType<FormSectionCompletePosUnbranded>;

const _FormSectionCompletedEndIncidentSchema = z.object({
  endingReason: z.object({
    value: z.enum([
      "startedFormInError",
      "formExpired",
      "nhsNotEngage",
      "medicalExamination",
      "other",
    ]),
    valueLabel: z.string(),
  }),
  incidentType: z.enum(IncidentTypeValues).optional(),
}) satisfies ZodType<FormSectionCompletedEndIncidentUnbranded>;

export type FormSectionCompletePos = z.infer<
  typeof _FormSectionCompletePosSchema
>;

export type FormSectionCompletedEndIncident = z.infer<
  typeof _FormSectionCompletedEndIncidentSchema
>;

type FormSectionCompleteIncidentMainUnbranded = {
  officer: string;
};

const _FormSectionCompleteIncidentMainSchema = z.object({
  officer: z.string(),
}) satisfies ZodType<FormSectionCompleteIncidentMainUnbranded>;

export type FormSectionCompleteIncidentMain = z.infer<
  typeof _FormSectionCompleteIncidentMainSchema
>;

export type FormSectionCompleteTriage = {
  incidentType: IncidentType;
};

export type FormSectionCompleteFinishForm = {
  incidentType: IncidentType;
};

export type FormSectionCompleteMcaAccompaniment = {
  accompanyingToEmergencyDepartment: "yes" | "no";
};

export type FormSectionCompleteProps = {
  type: FormSection;
  payload?:
    | FormSectionCompletePos
    | FormSectionCompleteIncidentMain
    | FormSectionCompletedEndIncident
    | FormSectionCompleteTriage
    | FormSectionCompleteFinishForm
    | FormSectionCompleteMcaAccompaniment;
};
